import { heatmapHourlyCursor } from '../hourly/heatmapHourlyCursor';

export function heatmapDailyCursor() {
  const cursor: any = heatmapHourlyCursor();

  cursor.drag = {
    dist: 10,
    y: false,
    x: false,
    __x: false,
  };

  return cursor;
}
